import { render, staticRenderFns } from "./BulkRentalServiceEditor.yaml?vue&type=template&id=d2597256&component"
import script from "./BulkRentalServiceEditor.yaml?vue&type=script&lang=ts&component"
export * from "./BulkRentalServiceEditor.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports